import { Fragment } from "react";
import { useFormContext } from "react-hook-form";

import TextArea from "~/common/components/ui/Textarea";
import { AddQuestionForm } from "~/providers/types/supplementalQuestions";

export const YesNoQuestionFields = () => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<AddQuestionForm>();

  return (
    <Fragment>
      <TextArea
        label="Question text"
        rows={5}
        {...register("text")}
        charactersCount={watch("text")?.length}
        maxCharacters={200}
        error={errors.text?.message}
      />
      <div className="flex flex-col gap-3">
        <p className="text-sm font-medium">Choices</p>
        <div className="flex h-11 w-full cursor-not-allowed items-center justify-between rounded-md border border-gray-300 bg-gray-200 p-2 text-sm text-gray-700">
          Yes
        </div>
        <div className="flex h-11 w-full cursor-not-allowed items-center justify-between rounded-md border border-gray-300 bg-gray-200 p-2 text-sm text-gray-700">
          No
        </div>
      </div>
    </Fragment>
  );
};
